<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="route_details_list"
        class="elevation-1 mytable"
        dense
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title
              >Add Route Details for
              {{
                selected_route_details.selectedrouteroutename
              }}</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small
                  >Add Route Details</v-btn
                >
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="
                              selected_route_details.selectedrouteroutename
                            "
                            persistent-hint
                            label="Selected Route"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            :items="route_stop_list"
                            item-text="name"
                            item-value="id"
                            v-model="editedItem.route_stop"
                            label="Select Route Stop List"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            type="number"
                            v-model="editedItem.distance"
                            persistent-hint
                            label="Actual Distance in KM's"
                            hint="(Max / Upper Boundary Distance)"
                            :rules="[(v) => !!v || 'required']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-checkbox
                            dense
                            v-model="editedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      class="mb-2 button"
                      color="primary"
                      @click="save"
                      :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.add="{ item }">
          <v-btn
            class="button"
            color="primary"
            @click="route_route_details(item)"
            >+ Route Details</v-btn
          >
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch
            inset
            v-model="item.isactive"
            :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"
          ></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      valid: false,
      route_id: null,
      route_details_list: [],
      route_stop_list: [],
      overlay: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      headers: [
        {
          text: "Sr No.",
          align: "left",
          sortable: false,
          value: "srno",
        },
        {
          text: "Route Name",
          align: "left",
          sortable: false,
          value: "routename",
        },
        {
          text: "Route Stop",
          align: "left",
          sortable: false,
          value: "routestop",
        },
        {
          text: "Actual Distance in KM",
          align: "center",
          sortable: true,
          value: "distance",
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "isactive",
        },
        {
          text: "Action",
          align: "left",
          sortable: true,
          value: "action",
        },
      ],
      selected_route_details: "",
      editedIndex: -1,
      editedItem: {
        id: "",
        routename: "",
        routestop: "",
        distance: "",
        isactive: true,
        route_stop: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Route Details"
        : "Edit Route Details";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  methods: {
    save() {
      if (this.editedIndex > -1) {
        // if (this.isValidated()) {
        axios
          .post("/Transport/editRouteDetails2", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //   Object.assign(
              //     this.route_details_list[this.editedIndex],
              //     this.editedItem
              //   );
              this.showSnackbar(
                "#4caf50",
                "Route Distance Updated Successfully..."
              ); // show snackbar on success
              this.onload();
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
        // }
      } else {
        const data = {
          data: this.editedItem,
          id: this.selected_route_details,
        };
        axios
          .post("/Transport/saveRouteDetails", data)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //   this.route_details_list.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "Route Details Added Successfully..."
              ); // show snackbar on success
              this.onload();
            } else if (res.data.code == "NA") {
              this.showSnackbar("#b71c1c", "Route Distance Already Present!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    },
    close() {
      this.dialog = false;
      //   this.initializeErrorMsgFalse();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
    },
    onload() {
      this.route_id = this.$route.params.route_id;
      if (this.$route.params.route_id == null) {
        this.$router.push({
          name: "transport-route",
        });
      } else {
        this.overlay = true;
        const data = {
          id: this.route_id,
        };
        axios
          .post("/Transport/addRouteDetails", data)
          .then((res) => {
            this.overlay = false;
            if (res.data.msg == "200") {
              this.overlay = false;
              this.route_details_list = res.data.route_details_list;
              this.route_stop_list = res.data.route_stop_list;
              this.selected_route_details = res.data.selected_route_details;
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            this.overlay = false;
          });
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.editedIndex = this.route_details_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Transport/toggleRouteDetails", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Route Status Changed!"); // show snackbar
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#b71c1c",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>